//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Routing.js";
import "../no/Builder.js";
import "../no/Expression.js";
import "../GeometricUtilities/GeometricUtilities.OnPathDimensionBuilder.js";
import "../Routing/Routing.SelectStock.js";
import "../no/Curve.js";
import "../no/GeometricUtilities.js";
import "../no/SelectObject.js";
let d=[[[1,"IntervalExpression",0,"Expression",0],[1,"MinimumClearance",0,"GeometricUtilities.OnPathDimensionBuilder",0],[0,"NumberOfPairs",1,0],[0,"ParallelReinforcement",1,"Routing.PathStockBuilder",0],[1,"ParentDuct",0,"Routing.SelectStock",0],[1,"PathCurve",0,"Curve",0],[0,"PerpendicularReinforcement",1,"Routing.PathStockBuilder",0],[0,"ReinforcementType",1,0],[1,"SpacingExpression",0,"Expression",0]],[[[],"UpdatePathCurve",{},0,0]],[]];
SPLM.Routing.DuctReinforcementBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Routing.DuctReinforcementBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Routing.DuctReinforcementBuilder.ReinforcementTypes = Object.freeze({
    "None" : "None", "Inside" : "Inside", "Outside" : "Outside"});

export default SPLM;